export default __webpack_public_path__ + "static/RobotoMono-600italic-53b43867955fbecc811a82030cefe8a4.woff2";